import { Component, Input, OnInit } from '@angular/core';
import { Option } from './search.model';
import { SearchService } from './search.service';


@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.sass']
})
export class SearchComponent implements OnInit {
  @Input() placeholderText = "Cerca tra le richieste...";
  options: Option[] = [
    {value: "search" , label: "Tutti"},
    {value: "id" , label: "Id richiesta"},
    {value: "email" , label: "Email"},
    {value: "fiscalCode" , label: "Codice fiscale"},
  ]
  searchField: string = "id";
  searchValue: string|null = null;

  constructor(
    public searchService: SearchService,
  ) { }

  ngOnInit(): void {
  }

  search(){
    this.searchService.searchField = this.searchField;
    this.searchService.search(this.searchValue);
  }

  resetSearchField(){
    this.searchService.searchField = this.searchField = 'id';
    this.searchService.searchValue = this.searchValue = null;
    this.search();
  }

}
